import { render, staticRenderFns } from "./Simulacao.vue?vue&type=template&id=08ec595e"
import script from "./Simulacao.vue?vue&type=script&lang=js"
export * from "./Simulacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports